import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useBreakpoint, useMediaAsset } from '~/composables';

interface Props {
  data: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryFaq',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { data: any };



const { getAssetUrl } = useMediaAsset();
const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');

const backgroundImage = computed(() =>
  getAssetUrl(
    isDesktop.value
      ? props.data.image
      : props.data.imageMobile ?? props.data.image,
  ),
);

const getImage = (src: string) => getAssetUrl(src) ?? undefined;

return { __sfc: true,props, getAssetUrl, isDesktop, backgroundImage, getImage }
}

})